import React, { useEffect, useState } from "react";
import Button from "../../components/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getNotificationsService,
  getStatisticsService,
} from "redux/services/general_service";
import { useTranslation } from "react-i18next";
import MetricsCard from "pages/dashboard/components/MetricsCard";

const MetricsOverview = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { statistics } = useSelector((state) => state.general);

  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (!token) {
      navigate("/login");
      return;
    }

    setUser({
      name: "Admin User",
      email: "admin@crm.com",
      role: "Administrator",
    });

    dispatch(getStatisticsService());
    dispatch(getNotificationsService());
  }, [navigate]);

  const mainMetrics = [
    {
      title: t("totalCustomers"),
      value: statistics?.all_clients_count,
      //  change: "+12.5%",
      changeType: "positive",
      icon: "Users",
      color: "primary",
    },
    {
      title: t("totalProducts"),
      value: statistics?.products_count,
      //  change: "+8.2%",
      changeType: "positive",
      icon: "Package",
      color: "accent",
    },
    {
      title: t("categories"),
      value: statistics?.all_categories_count,
      //  change: "+2.1%",
      changeType: "positive",
      icon: "Tags",
      color: "success",
    },
    {
      title: t("recentOrders"),
      value: statistics?.new_orders_count,
      //   change: "-3.4%",
      changeType: "negative",
      icon: "ShoppingCart",
      color: "warning",
    },
    // إضافة مقياس جديد لمستخدمي iOS
    {
      title: t("مستخدمي الآيفون"),
      value: statistics?.ios_users,
      //  change: "+5.0%",  // يمكنك إضافة تغيير إذا كان متوفراً
      changeType: "positive",
      icon: "Smartphone",
      color: "info",
    },
    // إضافة مقياس جديد لمستخدمي Android
    {
      title: t("مستخدمي الآندرويد"),
      value: statistics?.android_users,
      //  change: "+7.3%",  // يمكنك إضافة تغيير إذا كان متوفراً
      changeType: "positive",
      icon: "Smartphone",
      color: "secondary",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {mainMetrics.map((metric, index) => (
        <MetricsCard
          key={index}
          title={metric.title}
          value={metric.value}
          
          changeType={metric.changeType}
          icon={metric.icon}
          color={metric.color}
        />
      ))}
    </div>
  );
};

export default MetricsOverview;